"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Heading = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _withSpacing = _interopRequireWildcard(require("../withSpacing"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "heading": "tcl__Heading-2a4b5924",
  "largeSize": "tcl__Heading-07942a7b",
  "mediumSize": "tcl__Heading-3df55bba",
  "smallSize": "tcl__Heading-c6a9c264",
  "xSmallSize": "tcl__Heading-c8c7e524",
  "blackColor": "tcl__Heading-e7d4fe35",
  "whiteColor": "tcl__Heading-2af457f7",
  "isInline": "tcl__Heading-885d5129"
};
const sizeDetailsMap = {
  large: {
    className: styles.largeSize,
    defaultLevel: 1
  },
  medium: {
    className: styles.mediumSize,
    defaultLevel: 2
  },
  small: {
    className: styles.smallSize,
    defaultLevel: 3
  },
  'x-small': {
    className: styles.xSmallSize,
    defaultLevel: 4
  }
};
/**
 * Heading component to standardise sizes
 */

const Heading = ({
  size,
  level,
  isInline,
  color,
  className,
  children,
  ...props
}) => {
  const sizeDetails = sizeDetailsMap[size] || sizeDetailsMap.medium;
  const classname = (0, _classnames.default)(styles.heading, className, sizeDetails.className, {
    [styles.isInline]: isInline,
    [styles[`${color}Color`]]: color
  });
  const Element = `h${level || sizeDetails.defaultLevel}`;
  return /*#__PURE__*/_react.default.createElement(Element, _extends({
    className: classname
  }, (0, _omit.default)(props, ['style'])), children);
};

exports.Heading = Heading;
Heading.displayName = "Heading";
Heading.propTypes = { ..._withSpacing.propTypes,
  className: _propTypes.default.string,
  children: _propTypes.default.node,

  /**
   * Dictates whether the heading is inline or not.
   */
  isInline: _propTypes.default.bool,

  /**
   * Level of heading, this dictates the html tag that is outputted
   * but has no bearing on the visual size of the heading. If left
   * un-specified, a default will be picked based on the size.
   */
  level: _propTypes.default.oneOf([1, 2, 3, 4, 5]),

  /**
   * The visual size of the heading.
   */
  size: _propTypes.default.oneOf(['x-small', 'small', 'medium', 'large']),

  /**
   * Predefined icon color. By default it inherits from parent.
   */
  color: _propTypes.default.oneOf(['black', 'white'])
};
Heading.defaultProps = {
  size: 'medium',
  level: null,
  isInline: false,
  color: 'black',
  className: '',
  children: null
};

var _default = (0, _withSpacing.default)(Heading);

exports.default = _default;